import { Adapter } from '../models/Adapter';
import { Step } from '../models/Step';

type ProgressiveKeyStep = {
  key: string;
  title: string;
  analytics_ID: string;
  analytics_section: string;
  progressive: number;
};

class ConfigStepAdapter extends Adapter<ProgressiveKeyStep, Step> {
  adapt: (source: ProgressiveKeyStep) => Step = (
    source: ProgressiveKeyStep
  ) => {
    return new Step(
      source.key,
      source.title,
      source.analytics_ID,
      source.analytics_section,
      source.progressive,
      []
    );
  };
  adaptReverse: (source: Step) => ProgressiveKeyStep = (source: Step) => {
    return source
      ? {
          key: source.key,
          title: source.title,
          analytics_ID: source.analytics_ID,
          analytics_section: source.analytics_section,
          progressive: source.progressive,
        }
      : null;
  };
}

export const configStepAdapter = new ConfigStepAdapter();
